/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const BlackboardZipUploadEnabledSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('BLACKBOARD_ZIP_UPLOAD_ENABLED')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecBoolean)],
]);
export class BlackboardZipUploadEnabledSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return BlackboardZipUploadEnabledSettingParser.decode(input).map(res => new BlackboardZipUploadEnabledSetting(res));
    }
    static unsafeDecode(input) {
        return BlackboardZipUploadEnabledSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return BlackboardZipUploadEnabledSettingParser.encode(data);
    }
    static schema() {
        return BlackboardZipUploadEnabledSettingParser.schema();
    }
}
